import ContainerVolumeSlider from 'pages/Settings/PlansAndBilling/ContainerVolumeSlider';
import * as React from 'react';

interface Props {
  onChange: (value: number) => void;
  value: number;
}

export const VolumeSlider: React.FC<Props> = (props) => {
  return (
    <div className="space-y-4">
      <h4 className="font-medium">Select yearly container volume*:</h4>
      <div className="pb-0 pt-14">
        <ContainerVolumeSlider
          minVolume={0}
          availableVolumes={{
            3000: { category: '' },
            5000: { category: '' },
            8000: { category: '' },
            12000: { category: '' },
            18000: { category: '' },
            25000: { category: '' },
          }}
          volumeList={[3000, 5000, 8000, 12000, 18000, 25000]}
          canSelectSameVolume
          preSelectedVolume={props.value === 50000 ? undefined : props.value}
          onVolumeChange={(volume: number) => {
            if (volume === undefined) {
              // Laura's idea, if a user selects "more" we save 50000 in the backend
              props.onChange(50000);
            } else {
              props.onChange(volume);
            }
          }}
          period="monthly"
          disabled={false}
          hideInitial
        />
      </div>
    </div>
  );
};
VolumeSlider.displayName = 'VolumeSlider';
